import { type RefObject, useEffect, useState } from 'react'

/**
 * 观测滚动主列 clientWidth（图库瀑布列数、侧栏+管理栏展开时单列判断）。
 */
export function useScrollContainerWidth(
  ref: RefObject<HTMLElement | null> | undefined,
  attachSignal = 0,
): number | null {
  const [width, setWidth] = useState<number | null>(null)

  useEffect(() => {
    const el = ref?.current ?? null
    if (!el) {
      setWidth(null)
      return
    }

    const sync = () => setWidth(el.clientWidth)
    sync()

    const ro = new ResizeObserver(sync)
    ro.observe(el)
    window.addEventListener('resize', sync)
    return () => {
      ro.disconnect()
      window.removeEventListener('resize', sync)
    }
  }, [ref, attachSignal])

  return width
}
